// data/privacyPolicy.ts
export const privacyPolicy = [
  {
    section: '01. Information We Collect',
    content: [
      'We collect various types of information to provide and improve our services, including:',
      {
        type: 'list',
        items: [
          '**Personal Information You Provide:** This includes information you voluntarily submit when creating an account, using our AI tools, or communicating with us. This may include:',
          '**Contact Information:** Name, email address, phone number.',
          '**Account Credentials:** Username and password.',
          '**Legal Information:** Details about your legal inquiries, cases, or documents that you input into our AI system for analysis, drafting, or research. This could include facts of a case, parties involved, dates, and other relevant legal data. Please do not submit highly sensitive or confidential information that is not necessary for the functionality of our services.',
          '**Payment Information:** If you subscribe to paid services, payment details such as credit card information (processed securely by third-party payment processors).',
        ],
      },
      '**Information Collected Automatically:** When you use our website, we may automatically collect certain information about your device and usage patterns, such as:',
      {
        type: 'list',
        items: [
          '**Log Data:** IP address, browser type, operating system, referring URLs, pages viewed, and access times.',
          '**Usage Data:**  How you interact with our website and AI tools, including features used, search queries, and time spent on specific pages.',
          '**Cookies and Similar Technologies:** We use cookies and similar tracking technologies to enhance your experience, analyze trends, administer the website, track users’ movements around the website, and gather demographic information about our user base as a whole. You can control the use of cookies at the individual browser level.',
        ],
      },
    ],
  },
  {
    section: '02. How We Use Your Information',
    content: [
      'We use the information we collect for various purposes, including:',
      {
        type: 'list',
        items: [
          '**To Provide and Maintain Our Services:** This includes operating our website, enabling the functionality of our AI legal tools (e.g., analyzing documents, generating drafts, conducting research), and fulfilling your requests.',
          '**To Improve and Personalize Your Experience:** We use your information to understand how our services are used, identify areas for improvement, and customize content and features to your preferences.',
          '**For Communication:** To send you service-related notifications, updates, security alerts, and support messages. We may also send you marketing communications about our services, which you can opt out of at any time.',
          '**For Research and Development:** To analyze usage patterns, conduct research, and develop new features and functionalities for our AI platform. Your legal information submitted to our AI will be anonymized or aggregated for these purposes where possible, to protect your priva',
          '**For Security and Fraud Prevention:** To detect, prevent, and address technical issues, fraud, or other illegal activities.',
          '**To Comply with Legal Obligations:** To meet our legal and regulatory requirements.',
        ],
      },
    ],
  },
  {
    section: '03. Data Sharing & Security',
    content: [
      'We do not sell your personal information to third parties. We may share your information in the following circumstances:',
      {
        type: 'list',
        items: [
          '**With Service Providers:** We may share your information with trusted third-party service providers who assist us in operating our website, conducting our business, or providing services to you (e.g., hosting providers, payment processors, analytics providers). These service providers are obligated to protect your information and only use it for the purposes for which we disclose it to them.',
          '**For Legal Reasons:** We may disclose your information if required to do so by law or in response to valid requests by public authorities (e.g., a court order or subpoena). We may also disclose your information to protect our rights, property, or safety, or the rights, property, or safety of others.',
          '**In Case of Business Transfer:** In the event of a merger, acquisition, reorganization, bankruptcy, or sale of all or a portion of our assets, your information may be transferred to the acquiring entity.',
          '**With Your Consent:** We may share your information with your explicit consent or at your direction.',
          '**Aggregated or Anonymized Data:** We may share aggregated or anonymized data that does not directly identify you with third parties for various purposes, such as research, analytics, or marketing.',
        ],
      },
    ],
  },
  {
    section: '04. Data Security',
    content: [
      'We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, firewalls, and secure socket layer technology (SSL). However, no method of transmission over the internet or electronic storage is 100% secure. Therefore, while we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.',
    ],
  },
  {
    section: '05. Data Retention',
    content: [
      'We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When your information is no longer needed, we will securely delete or anonymize it.',
    ],
  },
  {
    section: '06. Your Choices and Rights',
    content: [
      'You have certain rights regarding your personal information:',
      {
        type: 'list',
        items: [
          '**Access and Correction:** You have the right to access and update your personal information. You can usually do this through your account settings.',
          '**Deletion:** You may request the deletion of your personal information, subject to certain legal exceptions.',
          '**Opt-Out of Marketing Communications:** You can opt out of receiving marketing emails from us by following the unsubscribe instructions in those emails.',
          '**Cookies:** You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of Legalligence may become inaccessible or not function properly.',
        ],
      },
      'To exercise any of these rights, please contact us using the information provided in the "Contact Us" section below.',
    ],
  },
  {
    section: '07. Children’s Privacy',
    content: [
      'Legalligence is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children under 18. If we become aware that we have inadvertently collected personal information from a child under 18, we will take steps to delete such information as soon as possible.',
    ],
  },
  {
    section: '08. Updates and Revisions to This Policy',
    content: [
      'We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or for other operational reasons. When we make changes, we will revise the “Last Updated” date at the top of this page. We encourage you to review this policy periodically to stay informed about how we are protecting your information.',
    ],
  },
  {
    section: '09. Contact Us',
    content: [
      'If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:',
      'Legalligence Customer Support  - team@legalligence.in',
    ],
  },
];
